import CinematicHero from '@/components/CinematicHero';
import AboutGamlens from '@/components/AboutGamlens';
import JourneyTimeline from '@/components/JourneyTimeline';
import Footer from '@/components/Footer';

export default function HomePage() {
  return (
    <>
      <CinematicHero />
      <AboutGamlens />
      <JourneyTimeline />
      <Footer />
    </>
  );
}
